module.exports = __webpack_public_path__ + "8fa6f8f7363b6f62a689726f54f0cca1.woff2";


//////////////////
// WEBPACK FOOTER
// ./web_modules/trustar-2.0/themes/common/assets/fonts/SplunkDataSans-regular.woff2
// module id = 3556
// module chunks = 39